import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./ReviewCard.module.scss";

export default function ReviewCard({
  header,
  title,
  subTitle,
  icon: Icon,
  imageSrc,
}) {
  return (
    <Grid2>
      <Grid2 className={styles.header}>{header}</Grid2>
      <Grid2 className={styles.card}>
        <Grid2 className={styles.imageSize}>
          {Icon ? (
            <Icon className={styles.icon} />
          ) : imageSrc ? (
            <img src={imageSrc} alt={title} className={styles.imageSrc} />
          ) : null}
        </Grid2>
        <Grid2 className={styles.headerText}>
          <Grid2 className={styles.title}>{title}</Grid2>
          <Grid2 className={styles.subTitle}>{subTitle}</Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
